/**
 * Style du bouton « Continuer avec Google » — injecté UNE fois dans <head>.
 *
 * Charte Google : fond BLANC, filet gris, texte sombre, « G » en quatre couleurs. Le bouton ne prend JAMAIS les couleurs de
 * la console (pas de mode sombre, pas de couleur d'accent) : il est identique partout. Seuls l'arrondi et la police se
 * laissent régler (`--gg-rayon`, `font: inherit`).
 */
const CSS = `
.gg-ou{display:flex;align-items:center;gap:12px;margin:14px 0;font-size:12.5px;opacity:.75;color:inherit}
.gg-ou::before,.gg-ou::after{content:"";flex:1;height:1px;background:currentColor;opacity:.3}
.gg-bouton{display:flex;align-items:center;justify-content:center;gap:12px;width:100%;min-height:44px;box-sizing:border-box;padding:0 14px;cursor:pointer;font:inherit;font-weight:600;font-size:14px;letter-spacing:.1px;color:#1f1f1f;background:#fff;border:1px solid #747775;border-radius:var(--gg-rayon,10px);transition:background .15s,box-shadow .15s}
.gg-bouton:hover:not(:disabled){background:#f2f2f2;box-shadow:0 1px 2px rgba(60,64,67,.3)}
.gg-bouton:focus-visible{outline:2px solid #4285f4;outline-offset:2px}
.gg-bouton:disabled{cursor:progress;background:#ffffff61;border-color:#1f1f1f1f;color:#1f1f1f61}
.gg-bouton svg{flex:none}
`
let injecte = false
export function injecterStylesGoogle(): void {
  if (injecte || typeof document === 'undefined') return
  injecte = true
  const s = document.createElement('style')
  s.setAttribute('data-connexion-google', '')
  s.textContent = CSS
  document.head.appendChild(s)
}
